import type { Size } from "@/constants/size"
import { cn } from "@/lib/utils"

import LogoSpinner from "./logo-spinner.tsx"

const CLASSES_BY_SIZE = {
  LG: { text: "text-6xl", gap: "gap-4" },
  MD: { text: "text-2xl", gap: "gap-3" },
  SM: { text: "text-lg", gap: "gap-2" },
} as const

export default function LogoWithText({
  size,
  subtitle,
}: {
  size?: keyof typeof Size
  subtitle?: string
}) {
  if (size) {
    return (
      <div className={cn("flex items-center", CLASSES_BY_SIZE[size].gap)}>
        <LogoSpinner size={size} />
        <div className={cn("font-black", CLASSES_BY_SIZE[size].text)}>
          WattBot
          {subtitle && <div className="text-lg">{subtitle}</div>}
        </div>
      </div>
    )
  }

  return (
    <div className="flex items-center gap-2 md:gap-3">
      <div className="md:hidden">
        <LogoSpinner size="SM" />
      </div>
      <div className="hidden md:block">
        <LogoSpinner size="MD" />
      </div>
      <div className="text-lg font-black md:text-2xl">
        WattBot
        {subtitle && <div className="text-lg">{subtitle}</div>}
      </div>
    </div>
  )
}
